import Modal from '../../common/Modal'
import PropTypes from 'prop-types'
import { useState } from 'react'

import SubmitButton from '../../common/buttons/SubmitButton'
import MCElement from '../../common/MCElement'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'

import styles from './CapacityWarningModal.module.scss'
import classNames from 'classnames'

const CapacityWarningModal = ({ showModal, closeModal, onSubmit, spotsAvailable, eventId, status }) => {
  let capacityWarningDisabledEventsIds = JSON.parse(sessionStorage.getItem('capacityWarningDisabledEventsIds')) || []
  const [isSelected, setIsSelected] = useState(capacityWarningDisabledEventsIds?.includes(eventId))

  const savePreferences = () => {
    isSelected
      ? capacityWarningDisabledEventsIds = capacityWarningDisabledEventsIds.filter(id => id !== eventId)
      : capacityWarningDisabledEventsIds.push(eventId)

    setIsSelected(!isSelected)
    sessionStorage.setItem('capacityWarningDisabledEventsIds', JSON.stringify(capacityWarningDisabledEventsIds))
  }

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      className={styles.capacityWarningModal}
      autoFocus
    >
      <div className={classNames('d-flex flex-column align-items-center', styles.modalContainer)}>
        <div className='d-flex justify-content-center align-items-center'>
          <WarningIcon/>
        </div>
        <div className={styles.modalContent}>
          <span className={styles.title}>Capacity Increase</span>
          <p className='mt-2 mb-4'>
            {`Marking this student attending will increase the capacity to ${ spotsAvailable + 1 }.
            \nAre you sure you want to continue?`}
          </p>
          <div className='w-100'>
            <SubmitButton
              onClick={() => onSubmit(status)}
              buttonMessage='Continue'
              buttonColor='orange-button'
            />
            <SubmitButton
              onClick={closeModal}
              buttonMessage='Cancel'
              buttonColor='navy-button'
            />
          </div>
          <div className='d-flex w-100 align-items-center justify-content-center mt-4 mb-2'>
            <MCElement
              type='checkbox'
              isSelected={isSelected}
              clicked={savePreferences}
            />
            <p className='ml-3'>I understand, please don&apos;t show this to me again</p>
          </div>
        </div>
      </div>
    </Modal>
  )
}

CapacityWarningModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  spotsAvailable: PropTypes.number.isRequired,
  eventId: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
}

export default CapacityWarningModal
